import $ from "jquery";

function trimWords(text, limit, append) {
    if (!text || !limit) return text;

    const words = text.split(/\s+/);
    if (words.length > limit) {
        return words.slice(0, limit).join(" ") + (append || "");
    }

    return text;
};

function setAlertHtml(alertData) {
    // Validate alertData before looping through it
    if (!alertData) {
        console.log('Cannot set alert html. Alert data is empty.');
        return;
    }
    if (!(alertData instanceof Array)) {
        console.log('Cannot set alert html. Alert data is a ' + (typeof alertData) + ', not an Array.');
        return;
    }

    const alerts = [];
    const topAlerts = [];
    const alertsSW = [];
    const topAlertsSW = [];

    for (let i = 0; i < alertData.length; i++) {
        // Skip if this is not active
        if (!alertData[i].is_active) {
            continue;
        }
        const alertCategory = alertData[i].alert_category;
        const strippedTitle = alertData[i].title.replace(/(<([^>]+)>)/gi, "");
        const content = (alertData[i].has_excerpt == true) ? alertData[i].excerpt : alertData[i].content;
        const alertURL = alertData[i].url;
        const alertContent = content
            .replace(/<p[^>]*>/g, "")
            .replace(/<\/p>/g, "<br />");
        const truncated = trimWords(alertContent, 60, '... [<a href="' + alertURL + '">Read More</a>]');

        const isSiteWide = alertData[i].site_wide;
        const isTopBanner = alertData[i].top_banner_alert;
        const alertTime = `${alertData[i].alert_time_formatted} ${alertData[i].time_zone ?? ''}`;
        
        let alertHTML;
    
        if (isTopBanner) {
            alertHTML = `
                <div class="alert-top-level d-flex" role="alert" aria-atomic="true">
                    <i class="far fa-exclamation-triangle"></i>
                    <p class="mb-0">
                        <strong>${alertTime}</strong>
                        ${alertCategory}: ${truncated}
                    </p>
                    <button class="ms-auto close-button px-0" aria-label="Close">
                        <span class="fa fa-times" aria-hidden="true"></span>
                    </button>
                </div>`;
            
            if (isSiteWide) {
                if (!topAlertsSW.includes(alertHTML)) {
                    topAlertsSW.push(alertHTML);
                }
            } else {
                if (!topAlerts.includes(alertHTML)) {
                    topAlerts.push(alertHTML);
                }
            }
        } else {
            alertHTML = `
                <div class="sandia-alert">
                    <span class="alert-copy">${alertCategory}: ${truncated}</span>
                    <p class="alert-dateTime">${alertTime}</p>
                    <button class="close">
                        <span class="fa fa-times" aria-hidden="true"></span>
                    </button>
                </div>`;
            
            if (isSiteWide) {
                if (!alertsSW.includes(alertHTML)) {
                    alertsSW.push(alertHTML);
                }
            } else {
                if (!alerts.includes(alertHTML)) {
                    alerts.push(alertHTML);
                }
            }
        }
    }
    
    // Normal alerts
    $(".top-level-alerts").html(topAlerts);
    $(".alert-system").html(alerts);
    
    // Site Wide Message
    $(".sw-top-level-alerts").html(topAlertsSW);
    $(".sw-alert-system").html(alertsSW);
}

function setTestData(html) {
    $('#sandia-alerts-test-data').html(html);
    $('#sandia-alerts-test-full-response, .sandia-alerts-test-data-header').show();
}

$(function () {
    // Only set Alert HTML if the alert placeholders exist
    
    if ($(".top-level-alerts")[0] || $(".alert-system")[0] || $(".sw-top-level-alerts")[0] || $(".sw-alert-system")[0]) {
        if (sandiaAlerts.curlFromServer) {
            if (sandiaAlerts.error) {
                console.log("Error fetching Sandia Alerts from " + sandiaAlerts.endpoint + ".");
            }
            setAlertHtml(sandiaAlerts.data);
        } else {
            $.getJSON(sandiaAlerts.endpoint, function (data) {
                setAlertHtml(data);
            })
                .fail(function () {
                    console.log("Error fetching Sandia Alerts from " + sandiaAlerts.endpoint + ".");
                });
        }
    }

    // Test on Settings page
    if ($('#sandia-alerts-test-data')[0]) {
        if (sandiaAlerts.curlFromServer) {
            if (sandiaAlerts.error) {
                setTestData("Error fetching Sandia Alerts from " + sandiaAlerts.endpoint + ": " + sandiaAlerts.error);
            } else {
                var formattedJson = JSON.stringify(sandiaAlerts.data, null, 4);
                setTestData(formattedJson);
            }
        } else {
            $.getJSON(sandiaAlerts.endpoint, function (data, testStatus, jqXHR) {
                var formattedXHR = JSON.stringify(jqXHR, null, 4);
                $('#sandia-alerts-test-full-response').html(formattedXHR);
                var formattedJson = JSON.stringify(data, null, 4);
                setTestData(formattedJson);
            })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    var formattedXHR = JSON.stringify(jqXHR, null, 4);
                    $('#sandia-alerts-test-full-response').html(formattedXHR);
                    setTestData("Error fetching Sandia Alerts from " + sandiaAlerts.endpoint + ": " + errorThrown);
                });
        }
    }

    // Close buttons
    $("body").on("click", ".alert-top-level .close-button", function () {
        this.parentNode.parentNode.classList.add("p-0");
        this.parentNode.parentNode.removeChild(this.parentNode);
        return false;
    });

    $("body").on("click", ".sandia-alert .close", function () {
        this.parentNode.parentNode.removeChild(this.parentNode);
        return false;
    });
});
